import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import styled from '@emotion/styled';

const BODY_FONT = 'Rubik-Regular, system-ui, sans-serif';

const Heading = styled(Typography)({
  fontSize: 26,
  fontWeight: 700,
  textAlign: 'left',
  marginBottom: 12,
  lineHeight: 1.3,
});

const Lede = styled(Typography)(({ theme }) => ({
  fontFamily: BODY_FONT,
  fontSize: 15,
  color: theme.palette.grey[700],
  textAlign: 'left',
  marginBottom: 24,
  lineHeight: 1.55,
}));

const ExpectTitle = styled(Typography)(({ theme }) => ({
  fontFamily: BODY_FONT,
  fontSize: 13,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: 1.2,
  color: theme.palette.grey[600],
  marginBottom: 12,
}));

const BulletList = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: '0 0 28px 0',
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
});

const Bullet = styled('li')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 12,
  fontFamily: BODY_FONT,
  fontSize: 14,
  lineHeight: 1.5,
  color: theme.palette.grey[800],
  '&:before': {
    content: '"✓"',
    color: theme.palette.primary.main,
    fontWeight: 700,
    flexShrink: 0,
    width: 16,
    textAlign: 'center',
  },
}));

const StartButton = styled(Button)({
  width: '100%',
  fontFamily: BODY_FONT,
  borderRadius: 25,
  padding: '14px 24px',
  fontSize: 16,
  fontWeight: 500,
  textTransform: 'none',
});

export default function VoucherIntro({ onStart }) {
  const { t } = useTranslation();

  return (
    <>
      <Heading variant="h1">{t('Assessment.welcomeHeading')}</Heading>
      <Lede>{t('Assessment.welcomeLede')}</Lede>

      <ExpectTitle>{t('Assessment.welcomeWhatToExpect')}</ExpectTitle>
      <BulletList>
        <Bullet>{t('Assessment.welcomeBullet1')}</Bullet>
        <Bullet>{t('Assessment.welcomeBullet2')}</Bullet>
        <Bullet>{t('Assessment.welcomeBullet3')}</Bullet>
        <Bullet>{t('Assessment.welcomeBullet4')}</Bullet>
        <Bullet>{t('Assessment.welcomeBullet5')}</Bullet>
      </BulletList>

      <StartButton variant="contained" color="primary" size="large" onClick={onStart}>
        {t('Assessment.voucherIntroStart')}
      </StartButton>
    </>
  );
}
